import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'

export const useChangeItemDraft = () => {
  const { storeId } = useStoreQuery()
  const { mutate } = useStore(storeId)

  const onChangeItemDraft = async ({
    callback,
    itemId,
    draft,
  }: {
    callback: () => Promise<void>
    itemId: number
    draft: boolean
  }) => {
    await callback()
    await mutate(
      data =>
        data && {
          ...data,
          items: data.items.map(item => {
            if (item.itemId === itemId) {
              item.draft = draft
            }
            return item
          }),
        },
      false,
    )
  }

  return { onChangeItemDraft }
}
